import React from "react";
import "../style/Footer.css";

const Footer = () => {
  return (
    <footer className="footer" id="footer">

      {/* Main Grid */}
      <div className="footer-main">

        {/* Brand Column */}
        <div className="footer-col footer-brand-col">

          <div className="footer-brand">
            <span className="footer-logo-text">STEADGEO</span>
            <span className="footer-tagline">
              Engineering &amp; Projects
            </span>
          </div>

          <p className="footer-about">
            STEADGEO Engineering &amp; Projects delivers professional
            engineering solutions, machinery spares, and industrial
            project support across India. Built on trust, precision,
            and a commitment to excellence.
          </p>

          <div className="footer-social">

           

            {/* WhatsApp */}
            <a
              href="https://wa.me/918113007755"
              aria-label="WhatsApp"
              className="social-icon-btn"
            >
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.126 1.528 5.855L0 24l6.335-1.652A11.954 11.954 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 0 1-5.006-1.371l-.36-.214-3.727.977.993-3.63-.234-.373A9.818 9.818 0 1 1 12 21.818z" />
              </svg>
            </a>

            {/* Email */}
            <a
              href="mailto:info@steadgeo.com"
              aria-label="Email"
              className="social-icon-btn"
            >
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
            </a>

          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h4 className="footer-col-heading">Quick Links</h4>

          <ul className="footer-links">
            <li><a href="/">Home</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#departments">Departments</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-col">
          <h4 className="footer-col-heading">Services</h4>

          <ul className="footer-links">
            <li><a href="#departments">Manufacturing</a></li>
            <li><a href="#departments">Spare Parts</a></li>
            <li><a href="#departments">Welding &amp; Fabrication</a></li>
            <li><a href="#departments">Tyre Services</a></li>
            <li><a href="#services">Project Support</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-col">
          <h4 className="footer-col-heading">Get In Touch</h4>

          <ul className="footer-contact-info">

            <li>
  <span className="contact-icon">
    <svg
      viewBox="0 0 24 24"
      width="16"
      height="16"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  </span>

  <div className="contact-text">
    <span>Kannur, Kerala</span>
    <span>KSIDC, Valiyavelicham 670643</span>
  </div>
</li>
            <li>
              <span className="contact-icon">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36 2 2 0 0 1 3.59 1h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.96a16 16 0 0 0 6.09 6.09l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </span>

              <a href="tel:+918113007755">0490 350 0300</a>
            </li>

            <li>
              <span className="contact-icon">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </span>

              <a href="mailto:info@steadgeo.com">
                info@steadgeo.com
              </a>
            </li>

          </ul>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} STEADGEO Engineering &amp; Projects.
          All Rights Reserved.
        </p>

        <p className="footer-bottom-right">
          Designed with precision.
        </p>
      </div>

    </footer>
  );
};

export default Footer;